import { render, staticRenderFns } from "./bindApi.vue?vue&type=template&id=101a2abb&scoped=true"
import script from "./bindApi.vue?vue&type=script&lang=js"
export * from "./bindApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a2abb",
  null
  
)

export default component.exports